import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { BoardDisplaySettingsService } from './services/board-display-settings.service';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'boards';

  // Inject service to ensure it's initialized early and CSS variable is set
  private boardDisplaySettingsService = inject(BoardDisplaySettingsService);
}
